import { SUPPORTED_LOCALES } from 'lib/constants.mjs';
const ENGAGE_BASE_URL = 'https://engage.metmuseum.org';

const isSupportedLocale = (locale: string) => {
	return SUPPORTED_LOCALES.includes(locale);
};

export const ensureEngageLocale = (url: string, locale: string = 'en') => {
	if (!url || !url.startsWith('https://engage.metmuseum.org')) {
		return url || '';
	}

	const parsedUrl = new URL(url);
	const pathSegments = parsedUrl.pathname.split('/').filter(Boolean);

	if (locale !== 'en' && isSupportedLocale(locale)) {
		if (!pathSegments?.[0] || isSupportedLocale(pathSegments[0])) {
			pathSegments[0] = locale;
		} else {
			pathSegments.unshift(locale);
		}
	} else {
		if (pathSegments.length && isSupportedLocale(pathSegments[0])) {
			pathSegments.shift();
		}
	}

	parsedUrl.pathname = pathSegments.join('/');
	return parsedUrl.toString();
};

export const getEngageBaseUrl = (locale: string = 'en') => {
	if (locale === 'en' || !isSupportedLocale(locale)) {
		return ENGAGE_BASE_URL;
	}

	return `${ENGAGE_BASE_URL}${locale ? `/${locale}` : ''}`;
};
